import {
  html,
  attr,
  on,
  TNode,
  prop,
  Value,
  When,
  Fragment,
} from '@tempots/dom'
import { Sidebar } from './sidebar'
import { Topbar } from './topbar'

export interface PageLayoutOptions {
  header: TNode
  content: TNode
  addPadding?: Value<boolean>
}

export function PageLayout({
  content,
  header,
  addPadding = true,
}: PageLayoutOptions) {
  const displaySidebar = prop(false)

  return html.div(
    attr.class('flex h-screen overflow-hidden bg-gray-50'),
    // Mobile overlay
    html.div(
      attr.id('mobile-overlay'),
      attr.class(
        displaySidebar.map(
          (open) =>
            `fixed inset-0 bg-gray-600 bg-opacity-75 z-40 lg:hidden transition-opacity ${
              open ? 'opacity-100' : 'opacity-0 pointer-events-none'
            }`
        )
      ),
      on.click(() => displaySidebar.set(false))
    ),
    // Sidebar
    Sidebar({
      opened: displaySidebar,
      setOpen: displaySidebar.set,
    }),
    // Main content area
    html.div(
      attr.class('flex-1 flex flex-col overflow-hidden h-full'),
      Topbar({ opened: displaySidebar, setOpen: displaySidebar.set }, header),
      html.main(
        When(
          addPadding,
          () =>
            Fragment(
              attr.class('overflow-auto flex flex-col items-center'),
              html.div(
                attr.class(
                  'p-4 sm:p-6 lg:p-8 mx-auto space-y-6 w-full sm:w-4/5'
                ),
                content
              )
            ),
          () =>
            Fragment(
              attr.class('h-full'),
              html.div(
                attr.class('flex-1 flex h-full w-full overflow-hidden'),
                content
              )
            )
        )
      )
    )
  )
}
